import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { apiClient } from '@/shared/api/client'
import { useTelegram } from '@/shared/lib/telegram'
import { ENABLE_MOCK_AUTH } from '@/shared/config/dev-mocks'

export interface UserSettings {
  notificationsEnabled: boolean
  orderUpdates: boolean
  eventReminders: boolean
  promotions: boolean
  preferredLanguage: string
  theme: string
  newProducts: boolean
  newEvents: boolean
  diaryPrompts: boolean
  cartReminders: boolean
}

interface UserSettingsResponse {
  success: boolean
  data: UserSettings
}

export type UpdateUserSettingsInput = Partial<UserSettings>

export function useUserSettings() {
  const { initData } = useTelegram()

  return useQuery({
    queryKey: ['user', 'settings'],
    queryFn: () => apiClient<UserSettingsResponse>('/api/user/settings', { initData }),
    enabled: ENABLE_MOCK_AUTH || !!initData,
    staleTime: 5 * 60 * 1000,
    select: (response) => response.data,
  })
}

export function useUpdateUserSettings() {
  const { initData } = useTelegram()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (settings: UpdateUserSettingsInput) => {
      if (!ENABLE_MOCK_AUTH && !initData) {
        throw new Error('Требуется авторизация')
      }

      return apiClient<UserSettingsResponse>('/api/user/settings', {
        method: 'PUT',
        body: JSON.stringify(settings),
        initData,
      })
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['user', 'settings'] })
    },
  })
}
